<template>
	<v-dialog
		v-model="dialog"
		persistent
		:width="$vuetify.breakpoint.smAndDown ? '100%' : '600px'"
	>
		<v-card :class="[$vuetify.breakpoint.smAndDown ? 'pa-2' : 'pa-4']">
			<v-card-title class="text-h5">
				{{ message.title }}
			</v-card-title>
			<v-card-subtitle>
				{{ message.subtitle }}
			</v-card-subtitle>
			<v-card-text class="pt-0 mt-0">
				<v-row>
					<v-col cols="12" class="mt-0 pt-0 pb-0 message">
						{{ message.message }}
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions class="d-flex justify-end">
				<v-btn color="primary" @click="dialog = false">
					ok
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { EventBus } from "@/main";

export default {
	name: "General",

	data() {
		return {
			message: {},

			dialog: false,
		};
	},

	created() {
		EventBus.$on("MessageGeneral", (message) => {
			this.message = message;

			this.dialog = true;
		});
	},
};
</script>

<style lang="css" scoped>
.message {
	font-size: 1rem;
	color: black;
}
</style>
